import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const configFirebase = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(configFirebase);

// Firebase references
export const db = firebase.firestore();
export const configurationCollection = db.collection("configuration");
export const usersCollection = db.collection("users");
export const questionnaireCollection = db.collection("questionnaires");
export const questionsCollection = db.collection("questions");
export const userDataCollection = db.collection("userData");
export const balliCollection = db.collection("balli");
export const balaCollection = db.collection("bala");
export const teacherConsentCollection = db.collection("teacher_consent");
export const studentConsentCollection = db.collection("student_consent");
export const parentConsentCollection = db.collection("parent_consent");
export const storage = firebase.storage();
